import { FileTypeEnum } from 'api/actor';
import { ContextEnum } from 'api/files';
import { ComponentKey } from 'enums/componentKey';
import { DocumentsFormFieldNames } from 'features/new-actor/enums/documentsFormFieldNames';
import { NaturalPersonWithDocumentsFormValues } from 'features/new-actor/types/optim/naturalPersonWithDocumentsFormValues';
import { InputsConfig } from 'types/form/inputsConfig';
import { naturalPersonInputsConfig } from './naturalPersonInputsConfig';

export const naturalPersonWithDocumentsInputsConfig: InputsConfig<Exclude<keyof NaturalPersonWithDocumentsFormValues, 'id'>> = {
  ...naturalPersonInputsConfig,
  [DocumentsFormFieldNames.Documents]: {
    componentKey: ComponentKey.DocumentSectionsUploader,
    name: DocumentsFormFieldNames.Documents,
    sections: [
      {
        id: 'identity',
        label: 'DOCUMENT_SECTION.DOCUMENTS_TO_PROVIDE',
        documents: [
          {
            name: 'DOCUMENT_TYPE.ID_CARD',
            fileType: FileTypeEnum.PieceIdentite,
            fieldName: `${DocumentsFormFieldNames.Documents}.${DocumentsFormFieldNames.Cni}`,
            context: ContextEnum.Person,
          },
          {
            name: 'DOCUMENT_TYPE.RIB',
            fileType: FileTypeEnum.Rib,
            fieldName: `${DocumentsFormFieldNames.Documents}.${DocumentsFormFieldNames.RIB}`,
            context: ContextEnum.Person
          }
        ]
      }
    ],
    completedSectionLabel: 'DOCUMENT_SECTION.SUBMISSION_COMPLETE',
    disabledSectionLabel: 'DOCUMENT_SECTION.SECTION_NOT_AVAILABLE',
    emptyMessage: 'DOCUMENT_SECTION.NO_DOCUMENTS_REQUIRED',
    acceptedFormats: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
    required: true
  }
};
